module.exports = __webpack_public_path__ + "img/DE00405.98282a46.png";